import { Type } from '@sinclair/typebox';
import { BaseTxSchema } from './base-tx.js';
export const LiquidityRemoveFields = {
    operation: Type.Literal('liquidityRemove'),
    lpBurned: Type.String(),
};
export const LiquidityRemoveTxSchema = Type.Object({
    ...BaseTxSchema.properties,
    ...LiquidityRemoveFields,
});
//# sourceMappingURL=liquidity-remove-tx.js.map